// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a3266612","130":"6f86b065","150":"c3b079e5","218":"1fdb70ee","231":"b661d0fa","339":"94d7c116","453":"aa03888e","488":"c5f6ec40","491":"2c0a9512","551":"b22906db","815":"ce0d4714","834":"67231e26","904":"c80297b5","915":"724e6bc5"}[chunkId] + ".chunk.js";
};